// extracted by mini-css-extract-plugin
export default {"m":"_2f11cd47a6","title":"_11e227f10d","feedback_inner_title":"_477c21e7e0","textarea":"a552283a00","radio":"cf9b382adf","text":"_0f6e3de915"};